import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { StaffLoginService } from 'src/app/services/staff-login/staff-login.service';
import { environment } from 'src/environments/environment';
import confetti from 'canvas-confetti';

@Component({
  selector: 'app-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.scss']
})
export class ReferralComponent implements OnInit {
  @Input() from_page: any;
  @Output() loginDashboard: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('getStartedButton') getStartedButton!: ElementRef;

  login_response: any;
  sessionData: any;

  industryControl: FormControl = new FormControl('', Validators.required);
  otherIndustry: FormControl = new FormControl('', [this.checkNoSpecialChars, this.checkNoUrlsOrScripts]);
  otherReference: FormControl = new FormControl('', [this.checkNoSpecialChars, this.checkNoUrlsOrScripts]);

  show_error: boolean = false;
  is_loading: boolean = false;
  is_celebrating: boolean = false;

  industries: any[] = [
    'Construction',
    'Facility Management',
    'Cleaning and Janitorial Services',
    'Supply Chain and Logistics',
    'Manufacturing',
    'Retail',
    'Real Estate',
    'Agriculture',
    'Hospitality',
    'Healthcare',
    'Education',
    'Non-profit',
    'Financial Service',
    'Automobile',
    'Mining & Natural Resources',
    'Other'
  ];

  industryFilterCtrl: FormControl = new FormControl();
  public filteredIndustry: ReplaySubject<any> = new ReplaySubject<any>(1);

  selected_referrenes: any[] = [];

  references: any[] = [
    {
      name: 'Search Engine',
      description: 'Google, Bing',
      is_checked: false
    },
    {
      name: 'AI Platform',
      description: 'ChatGPT, Grok, Gemini',
      is_checked: false
    },
    // {
    //   name: 'Social Media',
    //   description: 'ex: LinkedIn, Facebook, Quora',
    //   is_checked: false
    // },
    {
      name: 'Friend/Colleague',
      description: '',
      is_checked: false
    },
    {
      name: 'Email Campaign',
      description: '',
      is_checked: false
    },
    {
      name: 'Other',
      description: '',
      is_checked: false
    }
  ];

  private onDestroy = new Subject<void>();

  constructor(
    private staffLoginService: StaffLoginService,
    public router: Router,
    private route: ActivatedRoute
    ) {
      const navigation = this.router.getCurrentNavigation();
      const state = navigation?.extras?.state as {
        login_response: any
      };

      this.sessionData = this.route.snapshot.data.sessionData;
      if (this.sessionData && this.sessionData?.data) {
        const referral_data = this.sessionData?.data?.referral_data ? JSON.parse(this.sessionData?.data?.referral_data) : '';

        if (this.sessionData?.data?.is_referral_pending == '1') {
          this.login_response = {
            data: {
              mobile: this.sessionData?.data?.mobile,
              office_email: this.sessionData?.data?.office_email,
              country_name: this.sessionData?.data?.country_name,
              country_code: this.sessionData?.data?.country_code,
              sms_verified: this.sessionData?.data?.sms_verified,
              email_verified: this.sessionData?.data?.email_verified,
              client_region: this.sessionData?.data?.client_region ?? '',
              client_site_id: this.sessionData?.data?.client_site_id,
              client_id: this.sessionData?.data?.client_id,
              user_id: this.sessionData?.data?.user_id,
              sales_enquiry_id: this.sessionData?.data?.sales_enquiry_id,
              is_referral_pending: this.sessionData?.data?.is_referral_pending,
              referral_data: this.sessionData?.data?.referral_data,
              size: referral_data?.size
            }
          };
        };
      };

      if(state !== undefined) {
        if (state?.login_response) {
          this.login_response = state?.login_response;
        };
      };
    }

    ngOnInit(): void {
      this.filteredIndustry.next(this.industries);
      this.getMasterIndustryList();

      const newRefsArr: any[] = [];
      for (const [index, obj] of this.references.entries()) {
        const newObj = { ...obj, index };
        newRefsArr.push(newObj);
      };
      this.references = newRefsArr;

      this.industryControl.valueChanges.subscribe(value => {
      if (value && value.includes('Other')) {
        this.otherIndustry.setValidators([Validators.required, this.checkNoSpecialChars, this.checkNoUrlsOrScripts]);
      } else {
        this.otherIndustry.setValidators([this.checkNoSpecialChars, this.checkNoUrlsOrScripts]);
      };
      this.otherIndustry.updateValueAndValidity();
    });

    this.industryFilterCtrl.valueChanges.pipe(takeUntil(this.onDestroy)).subscribe((searchText) => {
      this.filterWithinDropdownItems(searchText, 'industries', 'filteredIndustry');
    });
  }

  // Custom validators for preventing special characters, URLs, and scripts
  checkNoSpecialChars(control: FormControl) {
    if (!control.value) return null;
    // Allow letters, numbers, spaces, hyphens, apostrophes, and periods
    const validPattern = /^[a-zA-Z0-9\s\-'\.]+$/;
    return validPattern.test(control.value) ? null : { specialChars: true };
  }

  checkNoUrlsOrScripts(control: FormControl) {
    if (!control.value) return null;
    // Check for URLs (http, https, www, .com, .org, etc.)
    const urlPattern = /(https?:\/\/|www\.|\.com|\.org|\.net|\.io|\.co|\.in|\.uk|\.de|\.fr|\.es|\.it|\.ca|\.au|\.jp|\.cn|\.br|\.ru|\.kr|\.mx|\.nl|\.se|\.ch|\.no|\.dk|\.fi|\.pl|\.pt|\.at|\.be|\.ie|\.nz|\.sg|\.my|\.th|\.vn|\.ph|\.id|\.tr|\.ae|\.sa|\.eg|\.za|\.ng|\.ke|\.gh|\.ug|\.tz|\.zm|\.mw|\.bw|\.na|\.sz|\.ls|\.ss|\.et|\.so|\.dj|\.km|\.mg|\.mu|\.sc|\.re|\.yt|\.tf|\.pf|\.nc|\.vu|\.fj|\.pg|\.sb|\.to|\.ws|\.ki|\.nr|\.tv|\.fm|\.mh|\.pw|\.ck|\.nu|\.tk|\.wf|\.as|\.gu|\.mp|\.pr|\.vi|\.us|\.um|\.bl|\.mf|\.gp|\.mq|\.lc|\.vc|\.bb|\.gd|\.ag|\.dm|\.kn|\.ai|\.ms|\.tc|\.vg|\.ky|\.bm|\.fk|\.gi|\.sh|\.ac|\.ta|\.io|\.cx|\.cc|\.nf|\.aq|\.hm|\.gs|\.bv|\.sj|\.pm|\.tf|\.yt|\.wf|\.pf|\.nc|\.vu|\.fj|\.pg|\.sb|\.to|\.ws|\.ki|\.nr|\.tv|\.fm|\.mh|\.pw|\.ck|\.nu|\.tk|\.wf|\.as|\.gu|\.mp|\.pr|\.vi|\.us|\.um|\.bl|\.mf|\.gp|\.mq|\.lc|\.vc|\.bb|\.gd|\.ag|\.dm|\.kn|\.ai|\.ms|\.tc|\.vg|\.ky|\.bm|\.fk|\.gi|\.sh|\.ac|\.ta|\.io|\.cx|\.cc|\.nf|\.aq|\.hm|\.gs|\.bv|\.sj|\.pm)/i;

    // Check for script tags and common script patterns
    const scriptPattern = /<script|javascript:|vbscript:|onload=|onerror=|onclick=|onmouseover=|onfocus=|onblur=|onchange=|onsubmit=|onreset=|onselect=|onunload=|onabort=|onbeforeunload=|onerror=|onhashchange=|onmessage=|onoffline=|ononline=|onpagehide=|onpageshow=|onpopstate=|onresize=|onstorage=|oncontextmenu=|oninput=|oninvalid=|onsearch=|onkeydown=|onkeypress=|onkeyup=|onmousedown=|onmouseenter=|onmouseleave=|onmousemove=|onmouseout=|onmouseup=|onwheel=|oncopy=|oncut=|onpaste=|onabort=|onbeforecopy=|onbeforecut=|onbeforepaste=|onblur=|onchange=|onclick=|oncontextmenu=|oncopy=|oncut=|ondblclick=|onerror=|onfocus=|onfocusin=|onfocusout=|onhashchange=|oninput=|oninvalid=|onkeydown=|onkeypress=|onkeyup=|onload=|onmessage=|onmousedown=|onmouseenter=|onmouseleave=|onmousemove=|onmouseout=|onmouseover=|onmouseup=|onmousewheel=|onoffline=|ononline=|onpagehide=|onpageshow=|onpaste=|onpopstate=|onresize=|onsearch=|onselect=|onstorage=|onunload=|onwheel/i;

    if (urlPattern.test(control.value) || scriptPattern.test(control.value)) {
      return { urlsOrScripts: true };
    }
    return null;
  }

  filterWithinDropdownItems(searchText, arrayToSearch, filterArrReplaySub) {
    if (!arrayToSearch || arrayToSearch.length == 0) {
      return;
    }
    if (!searchText) {
      this[filterArrReplaySub].next(this[arrayToSearch]);
      return;
    } else {
      searchText = searchText.toLowerCase();
    }
    this[filterArrReplaySub].next(
      this[arrayToSearch].filter((item: any) => {
        switch (arrayToSearch) {
          case 'industries':
            return item.toString().toLowerCase().indexOf(searchText) > -1;
          default:
            return item.toLowerCase().indexOf(searchText) > -1;
        }
      })
    );
  }

  getMasterIndustryList() {
    const credentials: any = {
      client_id: (String(this.login_response?.data?.client_id ?? '')),
      region: (String(this.login_response?.data?.client_region ?? '')),
      via: 'web_dashb'
    };

    this.staffLoginService.getMasterIndustryList(credentials).pipe(takeUntil(this.onDestroy)).subscribe((res: any) => {
      if (res && res?.code == '1') {
        this.industries = res?.data?.master_industry_list ?? this.industries;
        this.filteredIndustry.next(this.industries);
      }
    });
  }

  selectReference(selectedCard) {
    this.selected_referrenes.push(selectedCard);
    const selected_card = this.references.find(card => card.index == selectedCard.index);
    if (selected_card) {
      selected_card.is_checked = !selected_card.is_checked;
    };
    if (selectedCard.name && selectedCard.name.includes('Other')) {
      this.selected_referrenes = this.selected_referrenes.filter(card => card.name && card.name.includes('Other'));
      this.references = this.references.map(card => {
        if (!card.name || !card.name.includes('Other')) {
          return { ...card, is_checked: false };
        };
        return card;
      });

      this.otherReference.setValidators([Validators.required, this.checkNoSpecialChars, this.checkNoUrlsOrScripts]);
    } else {
      this.selected_referrenes = this.selected_referrenes.filter(card => !card.name || !card.name.includes('Other'));
      this.references.find(card => card.name && card.name.includes('Other')).is_checked = false;
      this.otherReference.setValidators([this.checkNoSpecialChars, this.checkNoUrlsOrScripts]);
    };
    this.otherReference.updateValueAndValidity();

    if (this.references.every(card => !card.is_checked)) {
      this.selected_referrenes = [];
    };
    if (this.selected_referrenes.length > 0) {
      this.show_error = false;
    };
  }

  isOtherSelected() {
    return this.references.find(card => card.name && card.name.includes('Other')).is_checked;
  }

  isReferenceSelected() {
    return this.selected_referrenes.length == 0;
  };

  loginToDashboard() {
    if (this.selected_referrenes.length > 0) {
      this.show_error = false;
    };
    if (this.industryControl.valid && this.otherIndustry.valid && this.otherReference.valid && this.selected_referrenes.length > 0) {
      // Trigger confetti animation
      this.triggerConfetti();
      
      // Add celebrate animation to button
      this.is_celebrating = true;
      setTimeout(() => {
        this.is_celebrating = false;
      }, 600);

      this.is_loading = true;

      const data = {
        industry: this.industryControl.value && this.industryControl.value.includes('Other') ? this.otherIndustry.value : this.industryControl.value,
        reference: this.selected_referrenes.some(card => card.name && card.name.includes('Other')) ? this.otherReference.value : this.selected_referrenes.map(card => card.name).join(','),
        size: this.login_response?.data?.size ?? ''
      };

      const credentials: any = {
        client_id: (this.login_response?.data?.client_id ?? ''),
        sales_enquiry_id: (this.login_response?.data?.sales_enquiry_id ?? ''),
        industry: data.industry,
        referral_data: JSON.stringify(data),
        via: "web_dashb"
      };

      // Track when API call starts and minimum wait time
      const startTime = Date.now();
      const minimumWaitTime = 2000; // 2 seconds
      let apiResponse: any = null;
      let apiError: any = null;
      let apiCompleted = false;

      // Start the API call immediately
      this.staffLoginService.updateReferralData(credentials).pipe(takeUntil(this.onDestroy)).subscribe((res: any) => {
        apiResponse = res;
        apiCompleted = true;
        
        // Check if minimum time has passed
        const elapsedTime = Date.now() - startTime;
        if (elapsedTime >= minimumWaitTime) {
          // Minimum time has passed, proceed immediately
          this.handleApiSuccess(apiResponse);
        } else {
          // Wait for remaining time
          const remainingTime = minimumWaitTime - elapsedTime;
          setTimeout(() => {
            this.handleApiSuccess(apiResponse);
          }, remainingTime);
        }
      }, err => {
        apiError = err;
        apiCompleted = true;
        console.log('err', err);
        
        // Check if minimum time has passed
        const elapsedTime = Date.now() - startTime;
        if (elapsedTime >= minimumWaitTime) {
          // Minimum time has passed, show error immediately
          this.is_loading = false;
        } else {
          // Wait for remaining time before showing error
          const remainingTime = minimumWaitTime - elapsedTime;
          setTimeout(() => {
            this.is_loading = false;
          }, remainingTime);
        }
      });
    } else {
      if (this.selected_referrenes.length == 0) {
        this.show_error = true;
      };
      this.industryControl.markAsTouched();
      if (this.industryControl.value && this.industryControl.value.includes('Other')) {
        this.otherIndustry.markAsTouched();
      };
      if (this.selected_referrenes.some(card => card.name && card.name.includes('Other'))) {
        this.otherReference.markAsTouched();
      };
    };
  }

  handleApiSuccess(res: any) {
    if (res.code == 1) {
      this.loginDashboard.emit(this.login_response);
    }
  }

  triggerConfetti() {
    // Get button element - try ViewChild first, fallback to querySelector
    let button: HTMLElement | null = null;
    
    if (this.getStartedButton && this.getStartedButton.nativeElement) {
      button = this.getStartedButton.nativeElement;
    } else {
      // Fallback: query the button directly by class or template reference
      button = document.querySelector('.continue-btn') as HTMLElement;
    }


    if (!button) {
      console.warn('Button element not found for confetti');
      return;
    }

    const rect = button.getBoundingClientRect();
    
    // Calculate center of button relative to viewport (0-1 range)
    // Position origin slightly above button center
    const originX = (rect.left + rect.width / 2) / window.innerWidth;
    const originY = (rect.top + rect.height / 4) / window.innerHeight; // Using height/4 to position above center

    // Your provided configuration
    const count = 200;
    const defaults = {
      origin: { x: originX, y: originY },
      zIndex: 9999
    };

    const fire = (particleRatio: number, opts: any) => {
      confetti({
        ...defaults,
        ...opts,
        particleCount: Math.floor(count * particleRatio)
      });
    };

    fire(0.25, {
      spread: 80,
      startVelocity: 55,
    });
    fire(0.2, {
      spread: 10,
    });
    fire(0.35, {
      spread: 40,
      decay: 0.91,
      scalar: 0.8
    });
    fire(0.1, {
      spread: 40,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2
    });
    fire(0.1, {
      spread: 40,
      startVelocity: 45,
    });
  }


  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }
}
